// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tinymce-disabled .tox-editor-container {
  pointer-events: none;
}

.tinymce-disabled .tox-editor-container .tox-editor {
  opacity: 0.5;
  /* Adjust the opacity to your preference */
  background-color: #b7b7b7 !important;
  /* Light grey background to indicate disabled state */
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/DynamicForm/formelements/EditorElement2.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;AACJ;;AAEE;EACE,YAAA;EAAe,0CAAA;EACf,oCAAA;EAAuC,qDAAA;AAG3C","sourcesContent":[".tinymce-disabled .tox-editor-container {\n    pointer-events: none;\n  }\n  \n  .tinymce-disabled .tox-editor-container .tox-editor {\n    opacity: 0.5;  /* Adjust the opacity to your preference */\n    background-color: #b7b7b7 !important;  /* Light grey background to indicate disabled state */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
